import useSessionStorage from '@ui/shared/storage/useSessionStorage';
import { useCallback } from 'react';

const ORGANIZATION_INVITE_SESSION_STORAGE_PREFIX = 'organizationInvite';

export default function useOrganizationInviteSessionStorage() {
  const [inviteId, setInviteId] = useSessionStorage<string | null>(
    'inviteId',
    null,
    {
      customPrefix: ORGANIZATION_INVITE_SESSION_STORAGE_PREFIX,
    },
  );
  const [secureToken, setSecureToken] = useSessionStorage<string | null>(
    'secureToken',
    null,
    {
      customPrefix: ORGANIZATION_INVITE_SESSION_STORAGE_PREFIX,
    },
  );
  const [didDismissModal, setDidDismissModal] = useSessionStorage<boolean>(
    'didDismissModal',
    false,
    {
      customPrefix: ORGANIZATION_INVITE_SESSION_STORAGE_PREFIX,
    },
  );

  const reset = useCallback(() => {
    setInviteId(null);
    setSecureToken(null);
    setDidDismissModal(false);
  }, [setDidDismissModal, setInviteId, setSecureToken]);

  return {
    inviteId,
    setInviteId,
    secureToken,
    setSecureToken,
    didDismissModal,
    setDidDismissModal,
    reset,
  };
}
